import { CommonFormProps } from '.';
import ReactMarkdown from 'react-markdown';
import { Modal } from 'src/components/baseComponents';
import { analytics } from 'src/services';
import { getAppointmentDetailsForAnalytics } from 'src/utils';

type Props = CommonFormProps;
const markdownStyles = {
  h1: {
    fontSize: '2em',
    fontWeight: 'bold',
    marginBottom: '0.5em',
  },
  h2: {
    fontSize: '1.5em',
    fontWeight: 'bold',
    marginBottom: '0.5em',
  },
};

export const DACForm = ({
  isOpen,
  appointment,
  onSave,
  form,
  loading,
}: Props) => {
  const dacForm = form.content as Record<
    (typeof appointment)['chat_phase'],
    { content: string; title: string }
  >;

  const phase = dacForm[appointment.chat_phase];

  const handleSubmit = async () => {
    analytics.track(
      'Clicked Continue In Html Video Form',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    await onSave({
      form_type: form?.form_type,
      response: { acknowledged: true },
    });
  };
  return (
    <div>
      {/** @ts-ignore */}
      <Modal
        open={isOpen}
        className={'dvprs_modal'}
        formClassName={'flex flex-col my-6'}
        initialValues={{}}
        submitButtonText="Continue"
        cancelButtonText=""
        closable={false}
        centered={true}
        fields={[]}
        handleSubmit={handleSubmit}
        onSubmitLoading={loading}
        disableSubmit={loading}
        titleBody={
          <div>
            <div className="text-lg font-medium">{phase?.title}</div>
          </div>
        }
        additionalBody={
          <ReactMarkdown
            components={{
              h1: ({ node, ...props }) => (
                <h1 style={markdownStyles.h1} {...props} />
              ),
              h2: ({ node, ...props }) => (
                <h2 style={markdownStyles.h2} {...props} />
              ),
            }}
          >
            {phase?.content}
          </ReactMarkdown>
        }
      />
    </div>
  );
};
